module.exports = __webpack_public_path__ + "static/media/driver_license_uploded.e0530022.svg";